import types from '../../mutation-types';

export const mutations = {
  [types.SET_ORDER_UI_FLAG]($state, data) {
    $state.uiFlags = {
      ...$state.uiFlags,
      ...data,
    };
  },

  [types.CLEAR_ORDERS]: $state => {
    $state.records = {};
    $state.sortOrder = [];
  },

  [types.SET_ORDER_META]: ($state, data) => {
    const { count, current_page: currentPage } = data;
    $state.meta.count = count || 0;
    $state.meta.currentPage = currentPage || 1;
  },

  [types.SET_ORDERS]: ($state, data) => {
    const sortOrder = data.map(order => {
      $state.records[order.id] = {
        ...($state.records[order.id] || {}),
        ...order,
      };
      return order.id;
    });
    $state.sortOrder = sortOrder;
  },

  [types.SET_ORDERS_LIST]: ($state, data) => {
    $state.records = {};
    $state.sortOrder = [];
    const sortOrder = data.map(order => {
      $state.records[order.id] = {
        ...($state.records[order.id] || {}),
        ...order,
      };
      return order.id;
    });
    $state.sortOrder = sortOrder;
  },

  [types.SET_ORDER_ITEM]: ($state, data) => {
    $state.records[data.id] = {
      ...($state.records[data.id] || {}),
      ...data,
    };

    if (!$state.sortOrder.includes(data.id)) {
      $state.sortOrder.push(data.id);
    }
  },

  [types.SET_ORDER_FILTERS](_state, data) {
    _state.appliedFilters = data;
  },

  [types.CLEAR_ORDER_FILTERS](_state) {
    _state.appliedFilters = [];
  },
};
